// src/slices/searchSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosClient from "../services/setupInterceptors";

export const fetchSearchSuggestions = createAsyncThunk(
  "search/fetchSuggestions",
  async (query, { rejectWithValue }) => {
    try {
      const { data } = await axiosClient.get(`/search/suggestions?query=${query}`);
      if (data?.success) return data.data.suggestions;
      return rejectWithValue("Failed to fetch suggestions");
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Error fetching suggestions");
    }
  }
);

const searchSlice = createSlice({
  name: "search",
  initialState: {
    query: "",
    suggestions: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearSearch(state) {
      state.query = "";
      state.suggestions = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSearchSuggestions.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSearchSuggestions.fulfilled, (state, action) => {
        state.loading = false;
        state.suggestions = action.payload || [];
      })
      .addCase(fetchSearchSuggestions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearSearch } = searchSlice.actions;
export default searchSlice.reducer;
